<script lang="ts">
    import { Col } from "sveltestrap";
    import { VerticalAlign } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Col xl="6" lg="12" md="6">
    <Card cardHeaderprops="pb-0" headerTitle={VerticalAlign}>
        <div slot="contentbody">
            <pre class="helper-classes">
                {`.baseline {
                    vertical-align: baseline;
                }
                .sub {
                    vertical-align: sub;
                }
                .super {
                    vertical-align: super;
                }
                .top {
                    vertical-align: top;
                }
                .text-top {
                    vertical-align: text-top;
                }
                .middle {
                    vertical-align: middle;
                }
                .bottom {
                    vertical-align: bottom;
                }
                .text-bottom {
                    vertical-align: text-bottom;
                }
                .initial {
                    vertical-align: initial;
                }
                .inherit {
                    vertical-align: inherit;
                }`}
            </pre>
        </div>
    </Card>
</Col>